import { render, staticRenderFns } from "./HelpdeskNotificactionDropdown .vue?vue&type=template&id=75d19388"
import script from "./HelpdeskNotificactionDropdown .vue?vue&type=script&lang=js"
export * from "./HelpdeskNotificactionDropdown .vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports